import { RegisteredFilterProps } from '../constant/constant';
import CustomDatePicker from './CustomDatePicker';
import Select, { DropdownIndicatorProps, components } from 'react-select';
import { DownCaretIcon } from '../assets/svgImages';
import {
  BulkEmailDetailSelectProps,
  FiltersState,
} from '../interface/interface';

const PatientRegistered = (props: BulkEmailDetailSelectProps) => {
  const DropdownIndicator = (props: DropdownIndicatorProps<true>) => {
    return (
      <components.DropdownIndicator {...props}>
        <DownCaretIcon />
      </components.DropdownIndicator>
    );
  };

  return (
    <div className="flex h-20 items-center">
      <label className="flex items-center space-x-3 me-5">
        <input
          type="checkbox"
          name="isRegistered"
          id="registered"
          className={`form-checkbox h-5 w-5 text-primary-blue-500 cursor-pointer`}
          checked={props.filters?.isRegistered}
          onChange={() => {
            props.setFilters((prev: FiltersState | undefined) => ({
              ...prev!,
              isRegistered: !prev?.isRegistered,
              registeredFilter: { label: '', value: '' },
              selectedRegisteredDate: undefined,
              betweenDate: undefined,
            }));
          }}
        />
        <span className={`text-md text-primary-blue-500 cursor-pointer`}>
          isRegistered
        </span>
      </label>
      {props.filters?.isRegistered && (
        <div className="flex">
          <div className="me-5">
            <label className="text-lg font-semibold text-secondary-pink-700">
              Filter By <span className="text-red-500">*</span>
            </label>
            <Select
              className="w-72 cursor-pointer"
              value={
                props.filters?.registeredFilter?.value
                  ? (props.filters?.registeredFilter as any)
                  : undefined
              }
              options={RegisteredFilterProps as any}
              onChange={(selected: any) => {
                props.setFilters((prev: FiltersState | undefined) => ({
                  ...prev!,
                  registeredFilter: selected,
                }));
              }}
              components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
              }}
            />
          </div>
          <div className="flex">
            <div>
              <label className="text-lg font-semibold text-secondary-pink-700">
                {props.filters?.registeredFilter?.value === 'BETWEEN'
                  ? 'From'
                  : 'Registered Date'}
                <span className="text-red-500">*</span>
              </label>
              <CustomDatePicker
                value={props.filters?.selectedRegisteredDate as Date}
                handleDate={(date) => {
                  props.setFilters((prev: FiltersState | undefined) => ({
                    ...prev!,
                    selectedRegisteredDate: date,
                  }));
                }}
                maxDate={true}
                className="w-72"
              />
            </div>

            {props.filters?.registeredFilter?.value === 'BETWEEN' ? (
              <div className="ms-5">
                <label className="text-lg font-semibold text-secondary-pink-700">
                  To <span className="text-red-500">*</span>
                </label>
                <CustomDatePicker
                  value={props.filters?.betweenDate as Date}
                  handleDate={(date) => {
                    props.setFilters((prev: FiltersState | undefined) => ({
                      ...prev!,
                      betweenDate: date,
                    }));
                  }}
                  maxDate={true}
                  className="w-72"
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientRegistered;
